<template>
  <div class="energy-comparison-navigation">
    <div class="navbar-sub">
      <div class="floating-container">
        <div class="navigation-component header comparer component">
          <div class="navbar-inner" style>
            <div class="navbar-container">
              <div class="navbar-base">
                <div class="logo" @click="$emit('logoClick')">
                  <img class="main-logo" :src="keuzeLogoImage" alt="Logo Keuze.nl"
                    title="Energie vergelijken op Keuze.nl">
                </div>
                <section class="nav-contents">
                  <slot name="nav" />
                  <div class="chat-component" @click="openChatProxy">
                    <icon icon="chat" size="sm" />
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="progressBar" />
    <slot name="addressBar" />
  </div>
</template>

<script>
import Icon from '../icon/Icon.vue';
import { openChat } from '../../../assets/js/helpers/chat';

export default {
  components: {
    Icon,
  },
  computed: {
    keuzeLogoImage() {
      return '/assets/keuze/keuze-logo.svg';
    },
  },
  methods: {
    openChatProxy(e) {
      openChat(e.currentTarget);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../assets/scss/all" as *;

.energy-comparison-navigation {

  .logo {
    cursor: pointer;
  }

  .navbar-sub {
    @include background-white;

    position: relative;
    z-index: 2;
  }

  .nav-contents {
    @include flex-row-between;
  }

  .chat-component {
    border-left: 1px solid $border-base;
    padding-left: 16px;

    .icon-element {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
